
  /* =========================================================
     MEISTER – Scroll-Handling
     Vorher lief bei JEDEM Scroll-Event ein getBoundingClientRect()
     (= erzwungenes Layout auf jedem Frame) und zwei console.log.
     Jetzt: passiver Listener + requestAnimationFrame-Drosselung,
     also maximal eine Messung pro Frame und kein Blockieren des Scrollens.
     ========================================================= */
  class StickyOnScroll extends HTMLElement {
    constructor() {
      super();
      this.currentScrollTop = 0;
      this.ticking = false;
      this.schedule = this.schedule.bind(this);
      window.addEventListener('scroll', this.schedule, { passive: true });

      const resizeObserver = new ResizeObserver(this.schedule);
      resizeObserver.observe(this);
    }

    schedule() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = this.getBoundingClientRect().height.toFixed(2);

      const isScrollingDown = scrollTop > this.currentScrollTop;
      const LogoStyle = this.dataset.logo;
      const isDesktop = window.innerWidth >= 1024;

      this.currentScrollTop = scrollTop;

      if (scrollTop > 100) {
        this.classList.add('is-sticky');

        if (isScrollingDown) {
          this.classList.add('is-hidden');
          this.closest('header')?.classList.add('is-hidden-header');
          document.body.classList.remove('header-sticky');
          document.body.style.setProperty('--dynamic_header_height', `0px`);
        } else {
          this.classList.remove('is-hidden');
          this.closest('header')?.classList.remove('is-hidden-header');
          document.body.classList.add('header-sticky');
          document.body.style.setProperty('--dynamic_header_height', `${headerHeight}px`);
        }

        if (isDesktop && LogoStyle === 'true' && this.querySelector('.half-width-menu')) {
          this.querySelector('.header--logo')?.classList.add('hidden');
        }
      } else {
        this.classList.remove('is-sticky', 'is-hidden');
        this.closest('header')?.classList.remove('is-hidden-header');
        document.body.classList.add('header-sticky');
        document.body.style.setProperty('--dynamic_header_height', `${headerHeight}px`);

        if (isDesktop && LogoStyle === 'true' && this.querySelector('.half-width-menu')) {
          this.querySelector('.header--logo')?.classList.remove('hidden');
        }
      }
    }
  }

  customElements.define('sticky-on-scroll', StickyOnScroll);

  class StickyAlways extends HTMLElement {
    constructor() {
      super();
      this.currentScrollTop = 0;
      this.ticking = false;
      this.schedule = this.schedule.bind(this);
      this.halfwidthMenuTransitionWidth();
      window.addEventListener('scroll', this.schedule, { passive: true });
      this.headerElement();
      this.resizeObserver = new ResizeObserver(this.halfwidthMenuTransitionWidth.bind(this));
      this.resizeObserver.observe(this.querySelector('[data-header-navigation]'));
    }

    schedule() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      this.headerHeight = this?.getBoundingClientRect().height;
      document.body.style.setProperty('--dynamic_header_height', `${this.headerHeight}px`);

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const LogoStyle = this.dataset.logo;
      if (scrollTop > 100) {
        if (this.classList.contains('is-sticky')) return;
        this.classList.add('is-sticky');

        if (window.innerWidth >= 1024) {
          if (LogoStyle == 'true' && this.querySelector('.half-width-menu')) {
            this.querySelector('.header--logo').classList.add('hidden');
          }
        }
      } else {
        this.classList.remove('is-sticky');
        if (window.innerWidth >= 1024) {
          if (LogoStyle == 'true' && this.querySelector('.half-width-menu')) {
            this.querySelector('.header--logo').classList.remove('hidden');
          }
        }
      }
    }

    headerElement() {
      this.headerHeight = this?.getBoundingClientRect().height;
      document.body.style.setProperty('--dynamic_header_height', `${this.headerHeight}px`);
    }

    halfwidthMenuTransitionWidth() {
      this.transitionWidth =
        this.querySelector('[data-header-navigation]').getBoundingClientRect().width -
        this.querySelector('[data-header-right]').getBoundingClientRect().width;
      this.querySelector('[data-header-navigation]').style.setProperty('--half_width_transition', `${this.transitionWidth}px`);

      this.headerElement();
    }
  }
  customElements.define('sticky-always', StickyAlways);

  class HamburgerMenu extends HTMLElement {
    constructor() {
      super();
      document.body.classList.remove('hamburger-menu-open');
      this.menuItems = this.querySelectorAll('li[data-hamburger-menu]');
      this.header = this.closest('header');
      this.toggler = this.header.querySelector('[data-hamburger-toggler]');
      this.closeBtn = this.querySelector('.cross_button')
      /* MEISTER: Guard – ohne Menüeinträge gab es hier einen TypeError */
      if(this.menuItems[0] && this.menuItems[0].hasAttribute('data-hamburger-item')){
        this.menuItems[0].classList.add('active')
      }
      this.menuItems.forEach((menu) => {
        menu.addEventListener('mouseenter', function(){
          if(menu.classList.contains('active')) return;
          const currentActive = this.querySelector('[data-hamburger-menu].active');
          if(currentActive){
            currentActive.classList.remove('active');
          }
          menu.classList.add('active');
        }.bind(this));
      })
      if(this.toggler){
        this.toggler.addEventListener('click',this.toggleHamburger.bind(this))
      }
       if(this.closeBtn){
        this.closeBtn.addEventListener('click',this.closeHamburger.bind(this))
      }
      this.updateHeaderHeight();
      this.resizeObserver = new ResizeObserver(this.updateHeaderHeight.bind(this));
      this.resizeObserver.observe(this);
    }


     toggleHamburger(){
       if(this.toggler.classList.contains('active')){
         this.closeHamburger();
       }
       else{
         this.openHamburger();
       }
     }

     openHamburger(){
        this.toggler.classList.add('active')
        /* MEISTER: Status für Screenreader */
        this.toggler.setAttribute('aria-expanded', 'true');
        this.toggler.setAttribute('aria-label', 'Menü schließen');
        setTimeout(() => {
          this.classList.add('active')
          document.body.classList.add('hamburger-menu-open', 'overflow-hidden')
        }, 150);

        this.style.display = 'flex'
        setTimeout(() => {
          this.querySelectorAll('[data-hamburger-menu]').forEach((item, index) => {
              setTimeout(() => {
                  item.classList.add('animate');
              }, index * 100);
          });
        }, 600);


     }
      closeHamburger(){
        this.classList.remove('active')
        this.toggler.setAttribute('aria-expanded', 'false');
        this.toggler.setAttribute('aria-label', 'Menü öffnen');
        setTimeout(() => {
          this.toggler.classList.remove('active')
          this.style.display = 'none'
          document.body.classList.remove('hamburger-menu-open', 'overflow-hidden')
          this.querySelectorAll('[data-hamburger-menu]').forEach((item, index) => {
          item.classList.remove('animate');
        });
        }, 800);
     }

     updateHeaderHeight() {

      this.announcementbarHeight = document.querySelector('.announcement-bar--main')?.getBoundingClientRect().height.toFixed(2) || 0;
      this.headerHeight = this.closest('[data-header-section]')?.getBoundingClientRect().height.toFixed(2) || 0;
      document.body.style.setProperty('--announcement_height', `${this.announcementbarHeight}px`);
      document.body.style.setProperty('--header_height', `${this.headerHeight}px`);

      const hasBothClasses = this.closest('[data-header-section]').classList.contains('desktop-transparent') || this.closest('[data-header-section]').classList.contains('mobile-transparent');
      if(hasBothClasses){
        document.body.style.setProperty('--desktop_transparent_header_height', `${this.headerHeight}px`);
        document.body.style.setProperty('--mobile_transparent_header_height', `${this.headerHeight}px`);
      }
    }

   }
  customElements.define('hamburger-menu', HamburgerMenu);

  class HeaderMenu extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.closest('[data-header-navigation]');
      this.parent = this.closest('.header--menu-item');
      this.innerMenu = this.querySelector('[header-menu-inner]');
      this.headerMenuMegaMenu = this.querySelector('[data-header-menu-megamenu]');
      this.headerElement = this.closest('.shopify-section');
      this.headerTag = this.headerElement?.querySelector('header');
      this.hideTimeout = null;
      this.windowScrollTop = window.scrollY;
      this.currentScrollTop = 0;

      /* MEISTER – Tastatur & Screenreader
         Der Trigger-Link bekommt aria-haspopup/aria-expanded, damit
         Screenreader den Zustand des Untermenüs ansagen. */
      this.triggerLink = this.parent?.querySelector('.header--menu-link');
      if (this.triggerLink && this.parent.classList.contains('has-children')) {
        this.triggerLink.setAttribute('aria-haspopup', 'true');
        this.triggerLink.setAttribute('aria-expanded', 'false');
      }

      this.addEventListener('mouseenter', this.showContent.bind(this));
      this.addEventListener('mouseleave', this.delayedHideContent.bind(this));

      /* MEISTER – Öffnen per Tastatur.
         Vorher griff die :focus-within-Regel nur unter html.no-js, d. h. mit
         aktivem JavaScript war das Megamenü per Tab überhaupt nicht erreichbar. */
      this.addEventListener('focusin', this.onFocusIn.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keydown', this.onKeyDown.bind(this));

      if (this.dataset.headerNavigation != 'hover') {
        this.addEventListener('click', this.toggleContent.bind(this));
      }
      this.querySelectorAll('[data-child]').forEach((item) => item.addEventListener('mouseenter', this.submenuInitializer.bind(this, item)));
      this.initHeader();
      this.addScrollListener();
      this.dropDownMenuPositions();
      this.offsetForDropDown();
      this.resizeObserver = new ResizeObserver(this.dropDownMenuPositions.bind(this));
      this.resizeObserver.observe(this.closest('[data-header-section]'));
      const resizeObserverDropdown = new ResizeObserver(this.offsetForDropDown.bind(this));
      resizeObserverDropdown.observe(this.closest('[data-header-section]'));
    }

    onFocusIn() {
      clearTimeout(this.hideTimeout);
      this.showContent();
    }

    onFocusOut(event) {
      /* Nur schließen, wenn der Fokus dieses Menü komplett verlässt */
      if (event.relatedTarget && this.contains(event.relatedTarget)) return;
      this.hideContent();
    }

    onKeyDown(event) {
      if (event.key !== 'Escape' && event.code !== 'Escape') return;
      if (!this.classList.contains('active')) return;
      event.preventDefault();
      this.hideContent();
      this.triggerLink?.focus();
    }

    offsetForDropDown() {
      const submenu = this.querySelector('[header-menu-inner]');
      if (submenu && this.classList.contains('header-dropdown')) {
        const container = this.closest('ul[is="menu-slide"]');
        if (!container) {
          return;
        }
        const containerRect = container.getBoundingClientRect();
        const menuRect = this.getBoundingClientRect();
        const submenuRect = submenu.getBoundingClientRect();
        const gap = 70;
        let offsetLeft = menuRect.left - containerRect.left;
        const maxOffsetLeft = containerRect.width - submenuRect.width - gap;
        if (offsetLeft + submenuRect.width > containerRect.width - gap) {
          offsetLeft = maxOffsetLeft;
        }

        offsetLeft = Math.max(offsetLeft, gap);
        submenu.style.left = `${offsetLeft}px`;
      }
    }


    submenuInitializer(item) {
      if(item.querySelector('[data-grand-child-list]')){

        if (item.querySelector('[data-grand-child-list]').classList.contains('active')) return;
        Array.from(item.closest('header-menu').querySelectorAll('[data-child]')).map((childlist) => {
          childlist.classList.remove('active');
        });
        Array.from(item.closest('header-menu').querySelectorAll('[data-grand-child-list]')).map((grandchildlist) => {
          grandchildlist.classList.remove('active');
        });
        item.classList.add('active');
        item.querySelector('[data-grand-child-list]').classList.add('active')
      }else{
        Array.from(item.closest('header-menu').querySelectorAll('[data-child]')).map((childlist) => {
          childlist.classList.remove('active');
        });
        Array.from(item.closest('header-menu').querySelectorAll('[data-grand-child-list]')).map((grandchildlist) => {
          grandchildlist.classList.remove('active');
        });
      }
    }

    dropDownMenuPositions() {
      if (window.innerWidth < 992) return false;
      this.querySelector('[header-menu-inner]').classList.remove("menu-position-left");
      const windowSize = window.innerWidth - 200;
      const rect = this.getBoundingClientRect();
      let currentPosition = rect.left + rect.width;

      const grandChildList = this.querySelector("[header-menu-inner]");
      if (grandChildList) {
        currentPosition += grandChildList.getBoundingClientRect().width;
      }

      if (currentPosition >= windowSize) {
        this.querySelector('[header-menu-inner]').classList.add("menu-position-left");
      }
    }

    connectedCallback() {
      if (this.headerElement) {
        this.resizeObserver = new ResizeObserver(this.updateHeaderHeight.bind(this));
        this.resizeObserver.observe(this.headerElement);
      }
      document.body.addEventListener('click', this.handleClickOutside.bind(this));
      this.innerMenu?.addEventListener('click', this.stopPropagation);
    }

    disconnectedCallback() {
      if (this.headerElement) {
        this.resizeObserver.unobserve(this.headerElement);
      }
      document.removeEventListener('click', this.handleClickOutside.bind(this));
      this.innerMenu?.removeEventListener('click', this.stopPropagation);
    }

    initHeader() {
      if (this.headerTag) {
        this.stickyHeader = this.headerTag.classList.contains('d-sticky-true');
        if (this.stickyHeader) {
          this.headerElement.classList.add('sticky-active');
          this.updateHeaderHeight();
        }
      }
    }

    addScrollListener() {
      /* MEISTER: passiv, damit das Scrollen nicht blockiert wird */
      window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    }

    handleScroll() {

      if (!this.stickyHeader) return;
      const scrollY = window.scrollY;
      this.headerElement.classList.toggle('is-sticky', scrollY > this.headerHeight);
      document.body.style.setProperty('--header_height', this.headerElement.classList.contains('is-hidden') ? '0px' : `${this.headerHeight}px`);
      this.windowScrollTop = scrollY;
    }

    updateHeaderHeight() {
      this.announcementbarHeight = document.querySelector('.announcement-bar--main')?.getBoundingClientRect().height.toFixed(2) || 0;
      this.headerHeight = this.headerElement.querySelector('[data-header-section]')?.getBoundingClientRect().height.toFixed(2) || 0;
      document.body.style.setProperty('--announcement_height', `${this.announcementbarHeight}px`);
      document.body.style.setProperty('--header_height', `${this.headerHeight}px`);

      const hasBothClasses = this.headerElement.querySelector('[data-header-section]').classList.contains('desktop-transparent') || this.headerElement.querySelector('[data-header-section]').classList.contains('mobile-transparent');
      if(hasBothClasses){
        document.body.style.setProperty('--desktop_transparent_header_height', `${this.headerHeight}px`);
        document.body.style.setProperty('--mobile_transparent_header_height', `${this.headerHeight}px`);
      }
    }


    deactivateAllMenus() {
      document.querySelectorAll('header-menu.active').forEach(menu => {
        menu.classList.remove('active');
        menu.closest('.header--menu-item')?.classList.remove('active');
        menu.closest('[data-header-navigation]')?.classList.remove('active');
        const parentItem = menu.closest('.header--menu-item');
        parentItem?.querySelector('.header--menu-link')?.setAttribute('aria-expanded', 'false');
        if(menu.querySelector('[data-header-menu-megamenu]')){
          menu.querySelector('[data-header-menu-megamenu]').style.clipPath = 'polygon(0 0,100% 0,100% 0%,0 0%)'
        }
        Array.from(menu.querySelectorAll('[data-child]'), (item) => {
          item.classList.remove('active');
        });
      });
      if (!document.querySelector('header-menu.active')) {
        if(document.body.classList.contains('megamenu-open')){
          document.body.classList.remove('megamenu-open');
        }

      }
    }


    /* MEISTER FLACKER-FIX (showContent)
       ---------------------------------
       Beim Laden verschieben nachladende Bilder/Schriften das Layout unter dem
       stehenden Cursor; der Browser feuert dabei wiederholt mouseenter. Die
       ursprüngliche Fassung schloss deshalb bei jedem Event zuerst ALLE Menüs
       und öffnete per setTimeout wieder -> sichtbares Zu-Auf-Flackern.

       1) Ist dieses Menü schon offen -> sofort return.
       2) Es werden nur ANDERE Menüs geschlossen.
       3) Das Menü wird SOFORT geöffnet. */
    showContent() {
      clearTimeout(this.hideTimeout);

      if (this.classList.contains('active')) return;

      document.querySelectorAll('header-menu.active').forEach((menu) => {
        if (menu === this) return;
        menu.classList.remove('active');
        const otherItem = menu.closest('.header--menu-item');
        otherItem?.classList.remove('active');
        otherItem?.querySelector('.header--menu-link')?.setAttribute('aria-expanded', 'false');
        menu.closest('[data-header-navigation]')?.classList.remove('active');
        const otherMega = menu.querySelector('[data-header-menu-megamenu]');
        if (otherMega) otherMega.style.clipPath = 'polygon(0 0,100% 0,100% 0%,0 0%)';
        Array.from(menu.querySelectorAll('[data-child]'), (item) => item.classList.remove('active'));
      });

      if (this.classList.contains('header-megamenu') || this.classList.contains('header-dropdown')) {
        document.body.classList.add('megamenu-open');
      }

      if (this.parent.classList.contains('has-children')) {
        this.wrapper.classList.add('active');
        this.parent.classList.add('active');
        this.headerMenuMegaMenu && (this.headerMenuMegaMenu.style.clipPath = 'polygon(0 0,100% 0,100% 100%,0 100%)');
        this.classList.add('active');
        this.triggerLink?.setAttribute('aria-expanded', 'true');
      }
    }


    hideContent() {
      this.classList.remove('active');
      this.wrapper.classList.remove('active');
      this.parent.classList.remove('active');
      this.triggerLink?.setAttribute('aria-expanded', 'false');
      this.headerMenuMegaMenu && (this.headerMenuMegaMenu.style.clipPath = 'polygon(0 0,100% 0,100% 0%,0 0%)');

      if (this.classList.contains('header-dropdown')) {
        Array.from(this.querySelectorAll('[data-child]'), (item) => {
          item.classList.remove('active');
        });
      }

      if (!document.querySelector('header-menu.active')) {
        document.body.classList.remove('megamenu-open');
      }
    }


    delayedHideContent() {
      this.hideTimeout = setTimeout(this.hideContent.bind(this), 300);
    }

    toggleContent(e) {
      e.preventDefault();
      /* Ein Klick soll das Menü nur öffnen, nie schließen.
         Da der Menüpunkt bereits per Hover geöffnet wird, würde ein echtes
         Toggle das gerade geöffnete Menü sofort wieder schließen. Das
         Schließen übernehmen mouseleave und handleClickOutside. */
      if (!this.classList.contains('active')) {
        this.showContent();
      }
    }

    handleClickOutside(event) {
      /* Nur schließen, wenn der Klick außerhalb der GESAMTEN Navigation liegt. */
      const navigation = this.closest('[data-header-navigation]');
      if (navigation && navigation.contains(event.target)) {
        return;
      }
      this.deactivateAllMenus();
    }

    stopPropagation(event) {
      event.stopPropagation();
    }
  }

  customElements.define('header-menu', HeaderMenu);

  class QuickShortMenu extends HTMLElement {
    constructor() {
        super();

        this.quickButton = document.querySelector('quick-short-menu');
        this.threshold = 300;
        this.isDesktop = window.innerWidth >= 1024;

        this.handleScroll = this.handleScroll.bind(this);
        this.updateParameters = this.updateParameters.bind(this);

        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener("resize", this.updateParameters);

        this.button = this.querySelector(".short-menu--button");
        this.icon = this.button.querySelector(".short-menu--button-icon");
        this.menuWrapper = this.querySelector('[data-menu]');
        this.menuLinks = this.querySelectorAll('[data-quick-menu-link]');

        this.updateParameters();
        this.setupEventListeners();
    }

    handleScroll() {
        if (window.scrollY > this.threshold) {
            this.fadeOut();
        } else {
            this.fadeIn();
        }
    }

    fadeOut() {
        if (!this.classList.contains('fade-in')) {
            this.classList.add('fade-in');
            this.classList.remove('fade-out');
            this.toggleLogoVisibility(false);
        }
    }

    fadeIn() {
        if (!this.classList.contains('fade-out')) {
            this.classList.add('fade-out');
            this.classList.remove('fade-in');
            this.toggleLogoVisibility(true);
        }
    }

    toggleLogoVisibility(visible) {
        const logo = document.querySelector('.header--logo');
        if (this.isDesktop && logo) {
            logo.classList.toggle('hidden', !visible);
        }
    }

    setupEventListeners() {
    this.button.addEventListener('click', () => {
        this.menuWrapper.classList.add('active');
        setTimeout(() => {
            this.menuWrapper.style.setProperty("pointer-events", `auto`);
        }, 350);
    });

    document.body.addEventListener('click', (event) => {
        const isClickInside = this.menuWrapper.contains(event.target) || this.button.contains(event.target);
        if (this.menuWrapper.classList.contains('active') && !isClickInside) {
            this.menuWrapper.classList.remove('active');
            this.menuWrapper.style.setProperty("opacity", `1`);
            setTimeout(() => {
                this.menuWrapper.style.removeProperty("opacity");
            }, 150);
            this.style.setProperty("--background-translate", `0`);
            this.menuWrapper.style.removeProperty("pointer-events");
            this.menuLinks.forEach(link => link.classList.remove('active'));
            this.querySelector('[data-index="0"]').classList.add('active');
        }
    });

    this.menuWrapper.addEventListener('mouseleave', () => {
        this.menuWrapper.classList.remove('active');
        this.menuWrapper.style.setProperty("opacity", `1`);
        setTimeout(() => {
            this.menuWrapper.style.removeProperty("opacity");
        }, 150);
        this.style.setProperty("--background-translate", `0`);
        this.menuWrapper.style.removeProperty("pointer-events");
        this.menuLinks.forEach(link => link.classList.remove('active'));
        this.querySelector('[data-index="0"]').classList.add('active');
    });

    this.menuLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
            let index = parseInt(link.dataset.index, 10);

            this.style.setProperty("--background-translate", `${index}`);
            this.style.setProperty("--short-item-height", `${link.getBoundingClientRect().height}px`);
            link.classList.add('active');

            this.menuLinks.forEach(sibling => {
                if (sibling !== link) {
                    sibling.classList.remove('active');
                }
            });
        });
    });
}
    updateParameters() {
        this.styleValues = getComputedStyle(this.button);
        this.childElementsGap = parseFloat(this.styleValues.gap) || 0;
        this.iconWidth = this.icon.clientWidth;

        const menuLinks = this.querySelectorAll('.short-menu--menu-link');
        let maxTextWidth = Math.max(...Array.from(menuLinks).map(link => link.textContent.length));

        this.buttonWidth = maxTextWidth > 25 ? 895 : maxTextWidth > 12 ? 655 : 395;

        if (this.isDesktop) {
            this.style.setProperty("--menu-max-width", `${this.buttonWidth}px`);
        } else {
            this.style.setProperty("--menu-max-width", `195px`);
        }
        this.style.setProperty("--motion-translate", `170px`);

        this.height = 'auto';
        this.menuList = this.querySelector('.short-menu--menu-list');
        if (this.menuList) {
            let menuItemHeight = this.menuLinks[0].clientHeight;
            let menuWrapperStyles = getComputedStyle(this.menuList);
            this.height = `${(this.menuLinks.length * menuItemHeight) + 3 + parseInt(menuWrapperStyles.paddingBottom) + parseInt(menuWrapperStyles.paddingTop)}px`;
        }

        this.style.setProperty("--translate-height", '415px');
    }

    getTextWidth(text, font) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.font = font;
        return context.measureText(text).width;
    }
}

customElements.define('quick-short-menu', QuickShortMenu);


  function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}


  if (isSafari()) {

   function setupMenuSlide() {

    if (window.innerWidth <= 768) {
        return;
    }

      const container = document.querySelector('[data-menus-container]');
      const leftArrow = document.querySelector('[data-arrow-left]');
      const rightArrow = document.querySelector('[data-arrow-right]');
      const menuContent = document.querySelector('[is="menu-slide"]');
      const scrollStep = 40;

      if (!container || !leftArrow || !rightArrow || !menuContent) return;

      function scrollLeft() {
        menuContent?.scrollBy({ left: -scrollStep, behavior: 'smooth' });
        updateArrowsImmediate(-scrollStep);
      }

      function scrollRight() {
        menuContent?.scrollBy({ left: scrollStep, behavior: 'smooth' });
        updateArrowsImmediate(scrollStep);
      }

      function updateArrows() {

        const maxScrollLeft = menuContent?.scrollWidth - menuContent?.clientWidth;
        if (menuContent?.scrollLeft === 0) {
          leftArrow.style.display = 'none';
        } else {
          leftArrow.style.display = 'flex';
        }

        if (menuContent.scrollLeft >= maxScrollLeft) {
          rightArrow.style.display = 'none';
        } else {
          rightArrow.style.display = 'flex';
        }
      }

      function updateArrowsImmediate(scrollChange) {
        const maxScrollLeft = menuContent.scrollWidth - menuContent.clientWidth;
        const newScrollLeft = Math.max(0, Math.min(menuContent.scrollLeft + scrollChange, maxScrollLeft));

        if (newScrollLeft === 0) {
          leftArrow.style.display = 'none';
        } else {
          leftArrow.style.display = 'flex';
        }

        if (newScrollLeft >= maxScrollLeft) {
          rightArrow.style.display = 'none';
        } else {
          rightArrow.style.display = 'flex';
        }
      }

      function callOffsetForDropDown() {

        const headerMenus = menuContent.querySelectorAll('li header-menu');
        headerMenus.forEach(headerMenu => {
          if (headerMenu.offsetForDropDown) {
            headerMenu.offsetForDropDown();
          }
        });
      }

      updateArrows();
      callOffsetForDropDown();

      leftArrow.addEventListener('click', scrollLeft);
      rightArrow.addEventListener('click', scrollRight);
      window.addEventListener('resize', updateArrows);
    }

    document.addEventListener('DOMContentLoaded', setupMenuSlide);
}else{

    class MenuSlide extends HTMLUListElement {
      constructor() {
        super();
        this.scrollStep = 40;
        this.container = null;
        this.leftArrow = null;
        this.rightArrow = null;
      }

      connectedCallback() {
        this.headerMenu = document.querySelector('header-menu');
        this.container = this.closest('[data-menus-container]');
        this.leftArrow = this.container.querySelector('[data-arrow-left]');
        this.rightArrow = this.container.querySelector('[data-arrow-right]');

        if (!this.leftArrow || !this.rightArrow) return;

        this.leftArrow.addEventListener('click', this.scrollLeftFun.bind(this));
        this.rightArrow.addEventListener('click', this.scrollRightFun.bind(this));

        window.addEventListener('resize', this.updateArrows.bind(this));
        this.updateArrows();
        this.callOffsetForDropDown();
      }

      scrollLeftFun() {
        this.scrollBy({ left: -this.scrollStep, behavior: 'smooth' });
        this.updateArrowsImmediate(-this.scrollStep);
        this.callOffsetForDropDown();
      }

      scrollRightFun() {
        this.scrollBy({ left: this.scrollStep, behavior: 'smooth' });
        this.updateArrowsImmediate(this.scrollStep);
        this.callOffsetForDropDown();
      }

      updateArrows() {
        const maxScrollLeft = this.scrollWidth - this.clientWidth;
        if (this.scrollLeft === 0) {
          this.leftArrow.style.display = 'none';
        } else {
          this.leftArrow.style.display = 'flex';
        }

        if (this.scrollLeft >= maxScrollLeft) {
          this.rightArrow.style.display = 'none';
        } else {
          this.rightArrow.style.display = 'flex';
        }
      }

      updateArrowsImmediate(scrollChange) {
      const maxScrollLeft = this.scrollWidth - this.clientWidth;
      const newScrollLeft = Math.max(0, Math.min(this.scrollLeft + scrollChange, maxScrollLeft));

      if (newScrollLeft === 0) {
        this.leftArrow.style.display = 'none';
      } else {
        this.leftArrow.style.display = 'flex';
      }

      if (newScrollLeft >= maxScrollLeft) {
        this.rightArrow.style.display = 'none';
      } else {
        this.rightArrow.style.display = 'flex';
      }
    }

    callOffsetForDropDown() {
      const headerMenus = this.querySelectorAll('li header-menu');
      headerMenus.forEach(headerMenu => {
        if (headerMenu.offsetForDropDown) {
          headerMenu.offsetForDropDown();
        }
      });
    }
  }

  customElements.define('menu-slide', MenuSlide, { extends: 'ul' });
}

  class MobileMenu extends HTMLElement {
    constructor() {
        super();

        this.header = this.closest('header');
        this.preventToggle = false;

        this.mobileToggler = this.header.querySelector('[data-mobile-toggler]');
        this.mobileToggler?.addEventListener('click', this.toggleMobileMenu.bind(this));

        /* MEISTER: aria-expanded am Burger-Button folgt dem tatsächlichen
           Zustand des Drawers – auch beim Schließen. Sonst bliebe der Button
           für Screenreader dauerhaft auf "geöffnet" stehen. */
        var drawer = document.querySelector('[data-drawer="mobile-menu-drawer"]');
        if (drawer && this.mobileToggler) {
          var toggler = this.mobileToggler;
          new MutationObserver(function () {
            var isOpen = drawer.classList.contains('show');
            toggler.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            toggler.setAttribute('aria-label', isOpen ? 'Menü schließen' : 'Menü öffnen');
          }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
        }

        /* MEISTER – Menuebaum wird nachgeladen (siehe mpMenuLaden weiter unten).
           Die beiden folgenden Bindungen standen frueher direkt hier im
           Konstruktor. Sie sind unveraendert in mpBindeMenuebaum() gewandert,
           damit sie nach dem Einhaengen des nachgeladenen Baums ein zweites
           Mal laufen koennen – dann aber ausschliesslich auf den neuen
           Elementen, deshalb wird nichts doppelt registriert.
           Rueckgaengig: Aufruf und Methode entfernen, Inhalt der Methode
           wieder hier einsetzen. */
        this.mpBindeMenuebaum(this);
    }

    /* MEISTER – Klick-Bindungen des Menuebaums.
       wurzel: Element, innerhalb dessen gebunden wird. Aus dem Konstruktor
       ist das die <mobile-menu> selbst, nach dem Nachladen nur der frisch
       gefuellte Container. Inhalt 1:1 wie vorher. */
    mpBindeMenuebaum(wurzel) {
        const bereich = wurzel || this;

        Array.from(bereich.querySelectorAll('[data-menu-item]'), (element) => {
            element.addEventListener('click', (event) => {
                if (!this.preventToggle) {
                    this.openMenus(element);
                }
            });
        });

        Array.from(bereich.querySelectorAll('[data-back-to-menu]'), (item) => {
            item.addEventListener('click', (event) => {
                this.backToMenu(item);
                this.preventToggle = true;
                setTimeout(() => {
                    this.preventToggle = false;
                }, 100);
            });
        });
    }

    openMenus(element) {
        element.classList.add('active');
    }

    backToMenu(item) {
        const parentMenuItem = item.closest('[data-menu-item]');
        if (parentMenuItem) {
            parentMenuItem.classList.remove('active');
        }
    }

    /* MEISTER – Öffnen des Burger-Menüs (überarbeitet)
       -----------------------------------------------
       Vorher: display:flex sofort, die Klasse "show" aber erst nach 400ms,
       danach ab 600ms eine Staffel über ALLE [data-mobile-item] mit
       index * 100ms. Auf dieser Seite sind das 145 Elemente – also 145
       Timer und über 14 Sekunden Laufzeit. Sichtbar bewirkt hat die
       Staffel nichts mehr (die .animate-Klasse verändert weder Deckkraft
       noch Position), spürbar war nur: tippen, 400ms nichts, dann steht
       das Menü da.

       Jetzt: display:flex, im nächsten Frame "show". Der Startzustand für
       die Bewegung kommt aus @starting-style in header.css (Abschnitt B13),
       die Dauer ebenfalls. */
    toggleMobileMenu() {
        const drawer = document.querySelector('[data-drawer="mobile-menu-drawer"]');
        if (!drawer) return;

        /* MEISTER – Menuebaum beim ersten Oeffnen nachladen. Der Aufruf
           blockiert nicht: Der Drawer faehrt sofort auf, waehrend die Section
           laedt. Ab dem zweiten Oeffnen passiert hier nichts mehr. */
        this.mpMenuLaden();

        drawer.style.display = 'flex';
        requestAnimationFrame(() => {
            drawer.classList.add('show');
            document.body.classList.add('overflow-hidden');
        });
    }

    /* MEISTER – Nachladen des Menuebaums (Section Rendering API)
       ---------------------------------------------------------
       WAS   Holt sections/mp-mobile-menu.liquid und haengt die Menue-
             eintraege in die im HTML stehende <ul class="mp-mobile-menu-lazy">.
       WARUM Der Baum war rund 123 KB in JEDER ausgelieferten Seite, obwohl
             ihn nur ein Bruchteil der Besucher aufklappt.
       WIE   Genau einmal pro Seitenaufruf, gesteuert ueber data-mp-state.
             Nach dem Einhaengen werden die Klick-Bindungen fuer die neuen
             Elemente nachgezogen (mpBindeMenuebaum) – ohne das bliebe der
             Baum stumm, weil der Konstruktor nur beim Seitenaufbau lief.
       FEHLER Schlaegt der Abruf fehl, steht dort ein Hinweis mit
             "Erneut versuchen" und ein Link auf alle Produkte – kein
             leeres Menue.
       RUECKGAENGIG Diese Methode, den Aufruf in toggleMobileMenu und
             mpBindeMenuebaum entfernen; Markup im Snippet zuruecktauschen. */
    mpMenuLaden() {
        const box = this.querySelector('.mp-mobile-menu-lazy');
        if (!box) return;

        const stand = box.dataset.mpState;
        if (stand === 'laedt' || stand === 'fertig') return;

        box.dataset.mpState = 'laedt';

        const url = box.dataset.mpMenuUrl;
        if (!url) {
            this.mpMenuFehler(box);
            return;
        }

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then((antwort) => {
                if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
                return antwort.text();
            })
            .then((html) => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const quelle = doc.getElementById('mp-mobile-menu-src');
                if (!quelle || quelle.children.length === 0) throw new Error('Antwort ohne Menueeintraege');

                /* Kindelemente uebernehmen, nicht die Transport-<ul> selbst –
                   so bleibt die DOM-Struktur exakt wie vor dem Umbau. */
                box.replaceChildren(...Array.from(quelle.children));
                box.dataset.mpState = 'fertig';

                this.mpBindeMenuebaum(box);
            })
            .catch((fehler) => {
                if (window.console && console.warn) {
                    console.warn('[MEISTER] Mobilmenue konnte nicht geladen werden:', fehler);
                }
                this.mpMenuFehler(box);
            });
    }

    /* MEISTER – Rueckfallebene, wenn der Abruf scheitert. */
    mpMenuFehler(box) {
        box.dataset.mpState = 'fehler';

        const eintrag = document.createElement('li');
        eintrag.className = 'mobile-menu--item mp-menu-fehler';

        const text = document.createElement('p');
        text.textContent = 'Das Menü konnte gerade nicht geladen werden.';

        const erneut = document.createElement('button');
        erneut.type = 'button';
        erneut.textContent = 'Erneut versuchen';
        erneut.addEventListener('click', () => {
            box.dataset.mpState = '';
            box.replaceChildren();
            this.mpMenuLaden();
        });

        const link = document.createElement('a');
        link.href = box.dataset.mpMenuFallback || '/collections/all';
        link.textContent = 'Alle Produkte ansehen';

        eintrag.append(text, erneut, link);
        box.replaceChildren(eintrag);
    }
  }

  customElements.define('mobile-menu', MobileMenu);

  /* MEISTER – Schliess-Animation des Burger-Menüs
     ---------------------------------------------
     Gleiche Sache wie bei Warenkorb und Suche: Das Theme setzt beim
     Schliessen sofort display:none, das Panel steht dabei noch an Ort und
     Stelle und verschwindet schlagartig. Wir halten den Drawer für die
     Dauer der Ausblendung im Layout, damit er herausgleiten kann.
     Der Wert muss zu --ms-exit in header.css (B13) passen. */
  (function () {
    var drawer = document.querySelector('[data-drawer="mobile-menu-drawer"]');
    if (!drawer || drawer.dataset.msExitBound) return;
    drawer.dataset.msExitBound = '1';

    var HALTEN = 280;            // --ms-exit (240ms) + Reserve
    var timer = null;
    var warOffen = false;        // stand der Drawer eben noch offen?
    var eigeneAenderung = false; // verhindert Rückkopplung mit dem Beobachter

    /* KORREKTUR: Die erste Fassung plante bei JEDER Klassenänderung
       ein Ausblenden ein — auch bei geschlossenem Drawer. Das Theme
       öffnet aber in zwei Schritten: erst display:flex, erst danach
       die Klasse "show". Fiel das Ausblenden in dieses Fenster,
       wurde der Drawer mitten im Öffnen versteckt — kurz dunkel,
       dann nichts. Ausführliche Beschreibung in cart-drawer.liquid. */
    function ausblenden() {
      timer = null;
      if (drawer.classList.contains('show')) return;   // inzwischen wieder offen
      eigeneAenderung = true;
      drawer.style.removeProperty('display');          // zurück auf den CSS-Wert
      eigeneAenderung = false;
    }

    new MutationObserver(function (records) {
      if (eigeneAenderung) return;

      if (drawer.classList.contains('show')) {
        warOffen = true;
        clearTimeout(timer);
        timer = null;
        return;
      }

      /* Theme bereitet das Öffnen vor: erst display:flex, "show" folgt später */
      var oeffnet = drawer.style.display === 'flex' && records.some(function (r) {
        return r.attributeName === 'style';
      });
      if (oeffnet) { clearTimeout(timer); timer = null; return; }

      if (!warOffen) return;     // war nie offen -> nichts auszublenden
      warOffen = false;

      if (drawer.style.display === 'none') {
        eigeneAenderung = true;
        drawer.style.display = 'flex';
        eigeneAenderung = false;
      }
      clearTimeout(timer);
      timer = setTimeout(ausblenden, HALTEN);
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'style'] });
  })();

  /* MEISTER – Megamenü-Wechsel-Addon (deaktiviert)
     Seit dem Umbau von showContent() erledigt die native Logik den
     Sofort-Wechsel selbst. Das Addon ist redundant und bleibt aus, damit
     nicht zwei Systeme dasselbe Menü öffnen/schließen. */
  (function () {
    window.__mmSwitchAddon = true;
  })();

  /* MEISTER – Fade-Hinweis am unteren Rand des Megamenüs */
  (function () {
    function initMegamenuFade() {
      if (window.__mmFadeAddon) return;
      var menus = Array.prototype.slice
        .call(document.querySelectorAll('header-menu'))
        .filter(function (h) { return h.querySelector('.header--menu-megamenu'); });
      if (!menus.length) return;

      function updateFade(mm) {
        var cont = mm.closest('.megamenu-container');
        if (!cont) return;
        var atBottom = (mm.scrollHeight - mm.clientHeight - mm.scrollTop) <= 2;
        var notScrollable = mm.scrollHeight <= mm.clientHeight + 2;
        cont.classList.toggle('mm-at-bottom', atBottom || notScrollable);
      }

      menus.forEach(function (hm) {
        var mm = hm.querySelector('.header--menu-megamenu');
        if (!mm) return;
        mm.addEventListener('scroll', function () { updateFade(mm); }, { passive: true });
        hm.addEventListener('mouseenter', function () {
          setTimeout(function () { updateFade(mm); }, 60);
          setTimeout(function () { updateFade(mm); }, 220);
        });
        hm.addEventListener('focusin', function () {
          setTimeout(function () { updateFade(mm); }, 60);
        });
      });

      window.__mmFadeAddon = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMegamenuFade);
    } else {
      initMegamenuFade();
    }
  })();

  /* Hinweis: Die Header-Icons (Lupe, Konto, Tasche) liegen als SVG
     direkt in snippets/header-icons.liquid. Hier stand vorher ein
     Skript, das sie nachträglich austauschte — das ist entfallen,
     seit die Icons an ihrem richtigen Ort stehen. */

  /* MEISTER – Kundenkonto-Icon auf die linke Seite
     ---------------------------------------------
     Suche und Warenkorb bleiben rechts, das Kundenkonto wandert nach
     links und steht bündig über dem ersten Menüpunkt.

     Reines Umhängen im DOM: Der Eintrag ist ein gewöhnlicher Link auf
     die Konto-Seite (kein Drawer-Auslöser), an ihm hängt also keine
     Logik, die durch den Umzug kaputtgehen könnte. Der Konto-Drawer
     selbst bleibt, wo er ist – er wird global angesteuert.

     Die Platzierung im Raster macht header.css (Abschnitt B1).
     Läuft das Skript nicht, bleibt das Konto einfach rechts stehen. */
  (function () {
    function moveAccount() {
      var wrapper = document.querySelector('.header--wrapper');
      if (!wrapper) return;
      /* nur greifen, solange es noch bei den rechten Icons sitzt */
      var acc = wrapper.querySelector('.header--icons .header--icon-item.account');
      if (!acc) return;
      acc.classList.add('ms-account-left');
      wrapper.appendChild(acc);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moveAccount);
    } else {
      moveAccount();
    }
  })();

  /* =========================================================
     MEISTER – Barrierefreiheit & Politur (neu)
     1) Platzhalter-Überschriften (href="#") wirklich neutralisieren
     2) Deutsche aria-labels für die Header-Icons nachrüsten
     3) Aktuellen Menüpunkt markieren (aria-current + Unterstrich)
     ========================================================= */
  (function meisterHeaderA11y() {
    if (window.__meisterHeaderA11y) return;
    window.__meisterHeaderA11y = true;

    function init() {
      var header = document.querySelector('[data-header-section]');
      if (!header) return;

      /* 1) Überschriften ohne echtes Ziel.
         pointer-events:none allein reicht nicht: der Link bleibt im Tab-Stop
         und wird von Screenreadern als "Link" angesagt. Ein <a> OHNE href ist
         weder fokussierbar noch wird es als Link ausgezeichnet – das Styling
         über die vorhandenen Klassen bleibt dabei vollständig erhalten. */
      header
        .querySelectorAll('.header--navigation-main a[href="#"], .header--menu-megamenu a[href="#"], .header--menu-submenu a[href="#"]')
        .forEach(function (a) {
          a.removeAttribute('href');
          a.setAttribute('role', 'presentation');
        });

      /* 2) Icon-Buttons brauchen einen Namen – und zwar auf Deutsch.
         Vorhandene aria-labels werden nicht überschrieben. */
      var labels = {
        search: 'Suche öffnen',
        cart: 'Warenkorb öffnen',
        account: 'Kundenkonto',
        wishlist: 'Merkliste'
      };
      header.querySelectorAll('.header--icon-item').forEach(function (item) {
        var el = item.querySelector('a, button');
        if (!el || el.getAttribute('aria-label')) return;
        Object.keys(labels).forEach(function (key) {
          if (item.classList.contains(key)) el.setAttribute('aria-label', labels[key]);
        });
      });

      /* 3) Aktuelle Seite in der Navigation kenntlich machen.

         WICHTIG – zwei getrennte Durchgänge:
         Seiten wie /collections/sale oder /collections/neuheiten tauchen
         zusätzlich als Eintrag INNERHALB des MARKEN-Megamenüs auf. Würde man
         einfach alle Links der Navigation prüfen, bekäme MARKEN die Markierung
         mit – genau der Effekt, dass zwei Punkte gleichzeitig leuchten.

         Durchgang 1: Nur die oberste Menüebene. Trifft dort ein Link exakt,
                      wird ausschließlich dieser markiert – fertig.
         Durchgang 2: Nur wenn oben KEIN Treffer war (z. B. auf einer einzelnen
                      Markenseite), wird der übergeordnete Menüpunkt markiert,
                      in dessen Untermenü die Seite liegt. Und zwar nur der
                      erste Treffer. */
      var here = window.location.pathname.replace(/\/+$/, '');
      if (!here) return;

      function hrefOf(a) {
        return (a.getAttribute('href') || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
      }

      function mark(link, item) {
        link.setAttribute('aria-current', 'page');
        link.classList.add('is-current');
        if (item) item.classList.add('has-current');
      }

      var topItems = header.querySelectorAll('.header--navigation-list > .header--menu-item');
      if (!topItems.length) {
        topItems = header.querySelectorAll('.header--navigation-main .header--menu-item');
      }

      /* Durchgang 1 – oberste Ebene */
      var i, trigger;
      for (i = 0; i < topItems.length; i++) {
        trigger = topItems[i].querySelector('.header--menu-link');
        if (trigger && trigger.hasAttribute('href') && hrefOf(trigger) === here) {
          mark(trigger, topItems[i]);
          return;
        }
      }

      /* Durchgang 2 – Untermenüs */
      for (i = 0; i < topItems.length; i++) {
        var subLinks = topItems[i].querySelectorAll('.header--menu-submenu a[href]');
        for (var j = 0; j < subLinks.length; j++) {
          if (hrefOf(subLinks[j]) === here) {
            mark(subLinks[j], topItems[i]);
            return;
          }
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
